export default function PendingUserApi( api ) {
  
  const connect = api.child( 'pendingUser' )

  function add( data ) {
    return connect.post( data )
  }

  function remove( data ) {
    return connect.delete( data )
  }

  function list( options ) {
    return connect.get( options )
  }

  return {
    list,
    add, 
    delete : remove
  }
}
